export async function getVehicles() { 
    const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRYz8D_W1DkPLAeagYTWr7dxAbcQwu7460SVWzIP4s-M2YoeiYPZiTOL2esGgOl17mrAP_BNtCBeu-5/pub?output=csv';
    try {
        const response = await fetch(csvUrl);
        const data = await response.text();
        const rows = data.split('\n').slice(1);
        const vehicles = rows.map(row => {
            const values = row.split(',');
            return {
                id: values[0],
                name: values[1],
                type: values[2],
                price: values[3],
                matriculation: values[4],
                fuel: values[5],
                km: values[6],
                image: values[7],
                pdf: values[8]
            };
        });
        return vehicles;
    }catch (error) {
        console.error('Errore durante il recupero dei dati CSV:', error);
        return [];
    }
}

export function showVehicle(vehicle, Swal) {
    Swal.fire({
        title: `Hai selezionato ${vehicle.name}`,
        text: `Prezzo: €${vehicle.price}`,
        imageUrl: `${vehicle.image}`,
        imageWidth: 350,
        imageHeight: 350,
        imageAlt: `${vehicle.name}`,
        confirmButtonText: "Visualizza dettagli"
    }).then((result) => {
        if(result.isConfirmed){
            window.open(vehicle.pdf, "_blank");
        }
    })
}

export function filterVehicles (vehicles, filter) {
    let filtered = vehicles;
    if (filter.type) {
      filtered = filtered.filter(vehicle => vehicle.type === filter.type);
    }
    if (filter.fuel) {
      filtered = filtered.filter(vehicle => vehicle.fuel === filter.fuel);
    }
    return filtered;
};

export const sortVehicles = (vehicles, sortKey, sortOrder) => {
    let sortedVehicles = [...vehicles];
    sortedVehicles.sort((a, b) => {
        if (sortKey === 'matriculation') {
            const [monthA, yearA] = a.matriculation.split('/').map(Number);
            const [monthB, yearB] = b.matriculation.split('/').map(Number);
            const dateA = new Date(yearA, monthA - 1); 
            const dateB = new Date(yearB, monthB - 1); 
            if (sortOrder === 'asc') {
                return dateA - dateB; 
            } else {
                return dateB - dateA; 
            }
        }else {
            if (sortOrder === 'asc') {
                return a[sortKey] > b[sortKey] ? 1 : -1;
            } else {
                return a[sortKey] < b[sortKey] ? 1 : -1;
            }
        }
    });
    return sortedVehicles;
};
